import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { catchError, exhaustMap, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { ComplicationsService } from 'src/app/services/complications.service';
import { clientErrored } from '../error/error.actions';
import { AppState } from '../reducers';
import * as complicationSearchActions from './complication-name-search.actions';
import { searchParams } from './complication-name-search.selectors';

@Injectable()
export class ComplicationNameSearchEffects {

	constructor(private actions$: Actions, private store: Store<AppState>, private complicationsService: ComplicationsService) {
	}

	newSearchRequested$ = createEffect(() =>
		this.actions$.pipe(
			ofType(complicationSearchActions.newSearchRequested),
			withLatestFrom(this.store.pipe(select(searchParams))),
			switchMap(([payload, searchParams]) => {
				return this.complicationsService.queryComplicationNames(payload.queryTerm, searchParams.appendsRetrieved * searchParams.resultsPerAppend, searchParams.resultsPerAppend).pipe(
					map(searchResults => (complicationSearchActions.newSearchSucceeded({ searchResults: searchResults }))),
					catchError((error: HttpErrorResponse) => [
						complicationSearchActions.newSearchFailed({ statusCode: error.status }),
						clientErrored({ toastMessage: 'Complication name search error', errorMessage: error.message })
					])
				)
			})
		)
	);

	appendResultsRequested$ = createEffect(() =>
		this.actions$.pipe(
			ofType(complicationSearchActions.appendResultsRequested),
			withLatestFrom(this.store.pipe(select(searchParams))),
			exhaustMap(([, searchParams]) => this.complicationsService.queryComplicationNames(searchParams.queryTerm, (searchParams.appendsRetrieved + 1) * searchParams.resultsPerAppend, searchParams.resultsPerAppend).pipe(
				map(searchResults => (complicationSearchActions.appendResultsSucceeded({ searchResults: searchResults }))),
				catchError((error: HttpErrorResponse) => [
					complicationSearchActions.appendResultsFailed({ statusCode: error.status }),
					clientErrored({ toastMessage: 'Complication name search append error', errorMessage: error.message })
				])
			))
		)
	);
}